import { useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { REFERRALS_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';

function ReportReferrals({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              value !== null
                ? applyExcelFormats(value, REFERRALS_COLUMNS[key]?.style?.numFmt)
                : null,
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList report={formattedReport} tableColumns={REFERRALS_COLUMNS} rowKey="uuid" />
    </>
  );
}

export default ReportReferrals;
